import SelectClearIcon from '@atlaskit/icon/core/migration/cross-circle--select-clear';
import SearchIcon from '@atlaskit/icon/core/migration/search';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import Textfield from '@atlaskit/textfield';
import React, { FunctionComponent, useMemo } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../i18n';

const searchBoxStyles = xcss({
  marginTop: 'space.150',
  marginBottom: 'space.250',
});

const clearActionStyles = xcss({
  marginRight: 'space.075',
  ':hover': {
    cursor: 'pointer',
  },
});

const searchActionStyles = xcss({
  marginLeft: 'space.075',
});

export interface FieldsSearchProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
}

const FieldsSearch: FunctionComponent<FieldsSearchProps> = ({
  searchValue,
  setSearchValue,
}) => {
  const { formatMessage } = useIntl();

  const clearAction = useMemo(
    () =>
      searchValue.length > 0 && (
        <Box
          role="button"
          tabIndex={0}
          xcss={clearActionStyles}
          onClick={() => setSearchValue('')}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setSearchValue('');
            }
          }}
          aria-label={formatMessage(
            messages['view-settings-panel.fields-search-clear-label']
          )}
        >
          <SelectClearIcon spacing="spacious" label="" />
        </Box>
      ),
    [formatMessage, searchValue.length, setSearchValue]
  );

  const searchIcon = (
    <Flex xcss={searchActionStyles}>
      <SearchIcon spacing="spacious" label="" />
    </Flex>
  );

  return (
    <Box xcss={searchBoxStyles}>
      <Textfield
        value={searchValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setSearchValue(e.target.value)
        }
        placeholder={formatMessage(messages['view-settings-fields.search-placeholder'])}
        elemBeforeInput={searchIcon}
        elemAfterInput={clearAction}
      />
    </Box>
  );
};

export default FieldsSearch;
